const getStorage = (ttl?: number | 'session') => (ttl === 'session' ? sessionStorage : localStorage);

const saveFiredOnce = (key: string, ttl?: number | 'session'): void => {
    const value = `true:${ttl && ttl !== 'session' ? Date.now() + ttl : ''}`;
    getStorage(ttl).setItem(`fire-once-${key}`, value);
};

const hasFiredOnce = (key: string, ttl?: number | 'session'): boolean => {
    const value = getStorage(ttl).getItem(`fire-once-${key}`);
    if (!value) {
        return false;
    }

    const [fired, expires] = value.split(':');
    if (fired !== 'true') {
        return false;
    }

    if (expires && parseInt(expires, 10) < Date.now()) {
        getStorage(ttl).removeItem(`fire-once-${key}`);

        return false;
    }

    return true;
};

export const fireOnce = (key: string, callback: () => void, ttl?: number | 'session'): void => {
    if (typeof window === 'undefined' || (ttl !== 'session' && !window.localStorage) || (ttl === 'session' && !window.sessionStorage)) {
        return;
    }

    if (!hasFiredOnce(key, ttl)) {
        saveFiredOnce(key, ttl);
        try {
            callback();
        } catch (error) {
            console.error(error);
        }
    }
};
